import styled from "styled-components";

import metrics from "../../styles/metrics";
import colors from "../../styles/colors";

import orderIcon from "../../assets/images/order-icon.png";

export const Container = styled.div`
  height: ${metrics.footerHeight}px;
  width: 100%;
  background: ${colors.footer.gradient};
  position: fixed;
  bottom: 0;
  display: flex;
  flex-direction: row;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.1);

  div {
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 10px 10px 10px 54px;

    p {
      position: relative;
    }

    span {
      margin-left: 5px;
      font-weight: 500;
    }
  }
`;

export const OrderContainer = styled.div`
  background: rgba(0, 0, 0, 0.05) url(${orderIcon}) no-repeat 10px center;

  div {
    align-items: left;
    padding-left: 0;
  }

  span {
    color: ${colors.primary};
    margin-right: 10px;
    font-weight: 600;
  }

  a {
    color: ${colors.text.dark};
    text-decoration: none;
    transition: color 0.2s ease;

    &:hover {
      color: ${colors.primary};
    }
  }
`;

export const IconProductType = styled.div<{ color: string }>`
  p {
    padding-left: 15px;
  }

  p:before {
    position: absolute;
    left: 0;
    top: 50%;
    margin-top: -5px;
    width: 10px;
    height: 10px;
    content: "";
    background: ${props => props.color};
    border-radius: 50%;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }
`;

export const LiquidContainer = styled.div`
  background: rgba(0, 0, 0, 0.03);
`;

export const GrossContainer = styled.div`
  background: rgba(0, 0, 0, 0.08);

  span {
    font-weight: 700;
    color: ${colors.text.dark};
  }
`;
